<template>
  <div class="signing-bottom-bar">
    <div class="hidden-xs-and-down" />
    <slot />
    <FriedLink
      class="powered-by-logo hidden-xs-and-down"
      href="https://www.getaccept.com"
      target="_blank"
    >
      <PoweredByLogo :aria-label="$t('powered-by-getaccept')" />
    </FriedLink>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import PoweredByLogo from '../../assets/powered-by-ga.svg';

export default defineComponent({
  components: {
    PoweredByLogo,
  },
});
</script>

<style lang="scss" scoped>
$logo-width: 4rem;

.signing-bottom-bar {
  display: flex;
  position: fixed;
  align-items: center;
  justify-content: space-between;
  z-index: 650;
  gap: var(--spacing-100);
  left: 0;
  right: 0;
  bottom: 0;
  min-height: var(--bottombar-height);
  padding: var(--spacing-75) var(--spacing-100);
  box-shadow: var(--shadow-2);
  background-color: var(--white);

  @media screen and (max-width: $xs) {
    max-height: 96px;
  }

  .powered-by-logo {
    width: $logo-width;
  }
}
</style>
